import { useState } from 'react';
import RegisterEmailFormCard from '../../components/authentication/RegisterEmailFormCard';
import RegisterCheckEmailCard from '../../components/authentication/RegisterCheckEmailCard';

export default function RegisterInitialize() {
  const [phase, setPhase] = useState<'email' | 'check-email'>('email');
  const [email, setEmail] = useState('');

  if (phase === 'check-email') {
    return (
      <RegisterCheckEmailCard
        email={email}
        onChangeEmail={() => setPhase('email')}
      />
    );
  }

  return (
    <RegisterEmailFormCard
      onSent={(sentEmail) => { setEmail(sentEmail); setPhase('check-email'); }}
    />
  );
}
